import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiError } from "../lib/api";
import { fmtDate } from "../lib/format";
import { Modal, Field, Badge, Spinner, EmptyState } from "../components/ui";

export default function Poc() {
  const [items, setItems] = useState<any[] | null>(null);
  const [action, setAction] = useState<any>(null);
  const [form, setForm] = useState<any>({});
  const [err, setErr] = useState<string | null>(null);
  const nav = useNavigate();

  const load = () => api.get("/poc").then((r) => setItems(r.data));
  useEffect(() => {
    load();
  }, []);

  if (!items) return <Spinner />;

  const doAction = async (relance: boolean) => {
    setErr(null);
    try {
      await api.post(`/poc/${action.source}/${action.id}`, { ...form, relance });
      setAction(null);
      setForm({});
      load();
    } catch (e) {
      setErr(apiError(e));
    }
  };

  return (
    <div data-testid="poc-page">
      <h1 className="mb-4 text-2xl font-extrabold text-green">POC en cours</h1>
      <div className="nx-card overflow-x-auto">
        {items.length === 0 ? (
          <EmptyState message="Aucun POC en cours" />
        ) : (
          <table className="nx-table">
            <thead><tr><th>Client</th><th>Produit</th><th>Échéance POC</th><th>Statut POC</th><th>Relances</th><th className="text-right">Actions</th></tr></thead>
            <tbody>
              {items.map((p) => (
                <tr key={`${p.source}-${p.id}`} data-testid={`poc-row-${p.id}`}>
                  <td className="font-semibold">{p.client_nom}</td>
                  <td>{p.produit}</td>
                  <td>{fmtDate(p.poc_fin)}</td>
                  <td><Badge className={p.poc_statut === "Réussi" ? "bg-lime-soft text-green" : p.poc_statut === "Échec" ? "bg-red-50 text-danger" : "bg-soft text-muted"}>{p.poc_statut || "—"}</Badge></td>
                  <td>{p.poc_relances}</td>
                  <td className="text-right">
                    <div className="flex justify-end gap-1.5">
                      <button data-testid={`poc-action-btn-${p.id}`} className="nx-btn-ghost !px-2 !py-1 text-xs" onClick={() => { setForm({ poc_statut: p.poc_statut || "", poc_fin: p.poc_fin || "" }); setAction(p); }}>
                        Gérer
                      </button>
                      <button
                        data-testid={`poc-open-btn-${p.id}`}
                        className="nx-btn-ghost !px-2 !py-1 text-xs"
                        onClick={() => nav(p.source === "kpax" ? `/recurrent?tab=kpax&env=${p.id}` : `/recurrent?contrat=${p.id}`)}
                      >
                        Ouvrir la source
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {action && (
        <Modal title={`POC — ${action.client_nom}`} onClose={() => setAction(null)} testId="poc-modal">
          <div className="space-y-3">
            <Field label="Statut POC">
              <select data-testid="poc-statut-select" className="nx-input" value={form.poc_statut || ""} onChange={(e) => setForm({ ...form, poc_statut: e.target.value })}>
                <option value="">—</option>
                {["En cours", "Attente", "Réussi", "Échec", "Prolongé"].map((s) => <option key={s}>{s}</option>)}
              </select>
            </Field>
            <Field label="Prolonger l'échéance jusqu'au">
              <input data-testid="poc-fin-input" type="date" className="nx-input" value={(form.poc_fin || "").slice(0, 10)} onChange={(e) => setForm({ ...form, poc_fin: e.target.value })} />
            </Field>
            {err && <p className="text-sm text-danger">{err}</p>}
            <div className="flex justify-end gap-2">
              <button className="nx-btn-ghost" onClick={() => setAction(null)}>Annuler</button>
              <button data-testid="poc-relance-btn" className="nx-btn-ghost" onClick={() => doAction(true)}>Enregistrer + relance</button>
              <button data-testid="poc-save-btn" className="nx-btn-primary" onClick={() => doAction(false)}>Enregistrer</button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
